/* eslint-disable import/no-cycle */
/* eslint-disable react/no-array-index-key */
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import isArray from 'lodash/isArray';
import styled, { withTheme } from 'styled-components';
import ReflexiveCard from '../UIElements/Card/ReflexiveCard';
import CreateScript from '../../util/CreateScript';
import GetElementFunc from '../../util/GetElement';
import { questionType } from '../../types';
import { rebuildQuestionList } from '../../utils';
import ListQuestions from '../List';
import NList from '../../n-list';
import { setListRelation } from '../../redux/actions/meta';
import './styles.css';
import AccordionQuestions from '../Accordion/AccordionQuestions';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  ${({ wrapperBg }) => `background: ${wrapperBg}`};
  ${({ justify }) =>
    justify &&
    `
    justify-content: ${justify};
    flex-wrap: wrap;
  `};
  @media (max-width: 767px) {
    flex-wrap: wrap;
  }
`;
// Get background from question based on deviceType
// eg: background[mobile], background[tablet] or background[desktop]
const getBgForDevice = (question, device) => {
  const bgObj = get(question, 'properties.background', {});
  return bgObj[device.toLowerCase()];
};
const isRequired = (question) => {
  return get(question, 'validations.required.value', false);
};

const skipUpdate = (currentRelatives, question) => {
  if (!currentRelatives) {
    return false;
  }

  const pId = get(question, 'properties.parent_list_id', '');
  const qId = question.question_id.split('_$ureify_')[1];

  let hasMatch = false;

  const parents = Object.keys(currentRelatives);
  for (let i = 0; i < parents.length; i += 1) {
    if (parents[i] === qId && currentRelatives[parents[i]] === pId) {
      hasMatch = true;
      break;
    }
  }

  return hasMatch;
};

const questionRenderer = ({
  questionList,
  sectionIndex,
  reflexLevel,
  overrideReflexLevel,
  changeMode,
  updateListRelation,
  activeSubsectionId,
  currentRelatives,
  showModalQuestions = false,
  csrConfig = null,
  requoteCsrConfig = null,
  hideReflexWrapper = false,
}) => {
  return questionList.map((item, index, qL) => {
    if (!showModalQuestions && item.isModalQuestion) {
      return null;
    }
    const csrSection = get(isArray(item) ? item[0] : item, 'properties.section.value');
    const csrGroup = get(isArray(item) ? item[0] : item, 'properties.group.value');
    const csrConfigObj = csrGroup === 'requote' ? requoteCsrConfig : csrConfig;
    if (csrSection && csrConfigObj && !csrConfigObj[csrSection].show) {
      return null;
    }
    const questionAppearance = get(item, 'properties.appearance.value', 'standard');
    if (questionAppearance === 'accordion') {
      return (
        <AccordionQuestions
          questionObj={ item }
          sectionIndex={ sectionIndex }
          originalQuestions={ item.questions.length ? item.questions : item.original_questions }
        />
      );
    }
    if (item.submission_type === 'all' && item.display_type === 'list') {
      return <NList listQ={ item } />;
    }
    if (isArray(item)) {
      return (
        <ReflexiveCard
          key={ `${sectionIndex}--${reflexLevel + 1}--${index}` }
          questionArray={ item }
          parentQuestionId={ get(item[0], 'question_id', '') }
          reflexLevel={ overrideReflexLevel ? 0 : reflexLevel + 1 }
          view={ get(item[0], 'properties.view', '') }
          hideWrapper={ get(item[0], 'properties.hideReflexWrapper', hideReflexWrapper) }
        >
          {questionRenderer({
            questionList: item,
            sectionIndex,
            reflexLevel: reflexLevel + 1,
            overrideReflexLevel,
            changeMode,
            updateListRelation,
            activeSubsectionId,
            currentRelatives,
            csrConfig,
            requoteCsrConfig,
            hideReflexWrapper,
          })}
        </ReflexiveCard>
      );
    }
    if (item.display_type === 'list') {
      const isOnlyQuestionInGroup = questionList.length === 2;
      return (
        <ListQuestions
          key={ item.question_id }
          sectionIndex={ sectionIndex }
          // questionObj={ item }
          reflexLevel={ reflexLevel }
          // listId={ item.question_id }
          listAddButtonLabel={ item.list_add_button_label }
          listAddBtnTheme={ item.list_add_button_theme }
          changeMode={ changeMode }
          // originalQuestions={ item.questions.length ? item.questions : item.original_questions }
          // listDisplay={ item.child_questions_completed_flag }
          isReview={ overrideReflexLevel }
          currentListAnswerIndex={ item.current_list_answer_index }
          hideReflexWrapper={ hideReflexWrapper }
          item={ item }
          qL={ qL }
          skipAutoScroll={ !isOnlyQuestionInGroup }
        />
      );
    }
    if (!item.display_type) {
      let nestedItems = Object.values(item);
      nestedItems = nestedItems.filter((i) => i && i.display_type);
      if (nestedItems.length) {
        return (
          <ReflexiveCard
            key={ `benf--${sectionIndex}--${reflexLevel + 1}--${index}` }
            questionArray={ nestedItems }
            reflexLevel={ reflexLevel + 1 }
            hideReflexWrapper={ hideReflexWrapper }
          >
            {questionRenderer({
              questionList: Object.values(nestedItems),
              sectionIndex,
              reflexLevel: reflexLevel + 1,
              changeMode,
              updateListRelation,
              activeSubsectionId,
              currentRelatives,
            })}
          </ReflexiveCard>
        );
      }
    }
    if (!item.is_hidden) {
      if (
        item.question_id.toString().indexOf('_$ureify_') > -1 &&
        !skipUpdate(currentRelatives, item)
      ) {
        updateListRelation(item, activeSubsectionId);
      }
      if (item.question_type === 'html_template') {
        return (
          <CreateScript
            key={ `${sectionIndex}--${reflexLevel + 1}--${index}` }
            item={ item }
            sectionIndex={ sectionIndex }
            required={ isRequired(item) }
          />
        );
      }
      let qItem;
      if (item.question_id === 'DefaultQuoteAmounts') {
        qItem = { ...item, className: `${process.env.REACT_APP_CARRIER_ID}-radio-group-wrapper` };
      } else {
        qItem = item;
      }
      return (
        <Fragment key={ `${sectionIndex}--${reflexLevel + 1}--${index}` }>
          <GetElementFunc
            questionObj={ qItem }
            sectionIndex={ sectionIndex }
            required={ isRequired(item) }
            isEditMode={ false }
            listParentId=''
            listIndex={ null }
          />
        </Fragment>
      );
    }
    return null;
  });
};

const QuestionRenderer = ({
  questionList,
  sectionIndex = 0,
  pageId,
  rebuild,
  updateListRelation,
  activeSubsectionId,
  changeMode,
  currentRelatives,
  screenViewport,
  theme,
  showModalQuestions,
  csrConfig,
  requoteCsrConfig,
}) => {
  const {
    config: {
      theme: { pageOverrides },
    },
  } = theme;
  const hideReflexWrapper = get(theme, 'config.theme.global.hideReflexWrapper', false);
  if (questionList.length) {
    if (rebuild === undefined || rebuild === true) {
      const updatedQuestionList = rebuildQuestionList(
        [...cloneDeep(questionList)],
        questionList[0].reflexive_index,
      );
      const overrideReflexLevel = pageId === 'quotereview' || pageId === 'review';
      /**
       * Group the inline questions if
       * Orientation is row
       * Orientation value is greater than 1
       */
      const orientationType = get(updatedQuestionList[0], 'properties.orientation.type', '');
      const orientationValue = get(updatedQuestionList[0], 'properties.orientation.value', 1);
      /**
       * Dynamically adding and removing screen_reader_label_id based on is_editable of Physician Information question.
       */
      questionList.forEach((q, index) => {
        if (
          q?.question_text === 'Physician Information' &&
          !q?.is_editable &&
          q?.screen_reader_label_id !== ''
        ) {
          questionList[index + 1].screen_reader_label_id = q?.screen_reader_label_id;
          q.screen_reader_label_id = '';
        }
      });
      const elements = [];
      let index = 0;
      if (orientationType === 'rows' && orientationValue > 1) {
        while (index < updatedQuestionList.length) {
          const isInline = get(updatedQuestionList[index], 'properties.inline.value', false);
          let endIndex = index + 1;
          if (
            isInline &&
            (screenViewport !== 'mobile' ||
              !(pageOverrides[pageId] && pageOverrides[pageId].skip2Column))
          ) {
            endIndex = index + orientationValue;
          }
          const inlineWrapperAlign = get(
            updatedQuestionList[index],
            'properties.align.value',
            'left',
          );
          const inlineQuestions = updatedQuestionList.slice(index, endIndex);
          const element = (
            <Wrapper
              name='wrapper'
              className={
                inlineQuestions && inlineQuestions[0]?.className
                  ? `${inlineQuestions[0]?.className}-wrapper`
                  : ''
              }
              align={ inlineWrapperAlign }
              justify={ get(inlineQuestions, `${[0]}.styles.justify`) }
              wrapperBg={ getBgForDevice(updatedQuestionList[index], screenViewport) }
            >
              {questionRenderer({
                questionList: inlineQuestions,
                sectionIndex,
                reflexLevel: 0,
                overrideReflexLevel,
                changeMode,
                csrConfig,
                requoteCsrConfig,
                hideReflexWrapper,
              })}
            </Wrapper>
          );
          elements.push(element);
          index = endIndex;
        }
        return <>{elements}</>;
      }
      return (
        <>
          {questionRenderer({
            questionList: updatedQuestionList,
            sectionIndex,
            reflexLevel: 0,
            overrideReflexLevel,
            changeMode,
            updateListRelation,
            activeSubsectionId,
            currentRelatives,
            showModalQuestions,
            csrConfig,
            requoteCsrConfig,
            hideReflexWrapper,
          })}
        </>
      );
    }

    return (
      <>
        {questionRenderer({
          questionList,
          sectionIndex,
          reflexLevel: 0,
          overrideReflexLevel: false,
          changeMode,
          updateListRelation,
          activeSubsectionId,
          currentRelatives,
          showModalQuestions,
          csrConfig,
          requoteCsrConfig,
          hideReflexWrapper,
        })}
      </>
    );
  }
  return null;
};

QuestionRenderer.propTypes = {
  questionList: PropTypes.arrayOf(questionType).isRequired,
  sectionIndex: PropTypes.number.isRequired,
  pageId: PropTypes.string.isRequired,
};

export default withTheme(
  connect(
    ({ questions, meta }) => {
      return {
        activeSubsectionId: questions.activeSubsectionId,
        currentRelatives: meta.listRelation[questions.activeSubsectionId],
        popupDetails: get(questions, 'popupDetails', {}),
        screenViewport: meta.screenViewport,
        csrConfig: questions.csrConfig,
        requoteCsrConfig: questions.requoteCsrConfig,
      };
    },
    (dispatch) => ({
      updateListRelation: (question, activeSubsectionId) => {
        dispatch(
          setListRelation({
            question,
            activeSubsectionId,
          }),
        );
      },
    }),
  )(QuestionRenderer),
);
